export interface DeploymentInfo {
  workerUrl: string
  buildType: 'pr' | 'local' | 'production' | 'unknown'
  branchName?: string
  prNumber?: number
  prUrl?: string
  buildTime: string
  commitHash?: string
  commitShortHash?: string
  commitMessage?: string
  commitAuthor?: string
  commitUrl?: string
}

interface DeploymentInfoProps {
  deploymentInfo: DeploymentInfo | null
}

export function DeploymentInfo({ deploymentInfo }: DeploymentInfoProps) {
  if (!deploymentInfo) {
    return (
      <div className="p-4 text-sm text-muted">
        No deployment information available
      </div>
    )
  }

  return (
    <div className="p-4 space-y-4">
      <div className="space-y-2">
        <div className="text-sm font-semibold">Worker URL</div>
        <div className="text-sm">
          <a 
            href={deploymentInfo.workerUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-accent hover:underline break-all"
          >
            {deploymentInfo.workerUrl}
          </a>
        </div>
      </div>

      <div className="space-y-2">
        <div className="text-sm font-semibold">Build Type</div>
        <div className="text-sm">
          <span className="inline-block px-2 py-1 rounded bg-accent/10 text-accent text-xs font-medium">
            {deploymentInfo.buildType.toUpperCase()}
          </span>
        </div>
      </div>

      {deploymentInfo.commitShortHash && (
        <div className="space-y-2">
          <div className="text-sm font-semibold">Commit</div>
          <div className="text-sm">
            {deploymentInfo.commitUrl ? (
              <a 
                href={deploymentInfo.commitUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-accent hover:underline font-mono"
              >
                {deploymentInfo.commitShortHash}
              </a>
            ) : (
              <span className="font-mono text-muted">{deploymentInfo.commitShortHash}</span>
            )}
            {deploymentInfo.commitMessage && (
              <div className="text-xs text-muted mt-1 italic">
                "{deploymentInfo.commitMessage}"
              </div>
            )}
            {deploymentInfo.commitAuthor && (
              <div className="text-[10px] text-muted/60 mt-0.5">
                by {deploymentInfo.commitAuthor}
              </div>
            )}
          </div>
        </div>
      )}

      {deploymentInfo.buildType === 'pr' && deploymentInfo.prNumber && (
        <div className="space-y-2">
          <div className="text-sm font-semibold">Pull Request</div>
          <div className="text-sm">
            {deploymentInfo.prUrl ? (
              <a 
                href={deploymentInfo.prUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-accent hover:underline"
              >
                PR #{deploymentInfo.prNumber}
              </a>
            ) : (
              `PR #${deploymentInfo.prNumber}`
            )}
          </div>
        </div>
      )}

      {deploymentInfo.buildType === 'local' && deploymentInfo.branchName && (
        <div className="space-y-2">
          <div className="text-sm font-semibold">Branch</div>
          <div className="text-sm font-mono text-muted">
            {deploymentInfo.branchName}
          </div>
        </div>
      )}

      {deploymentInfo.branchName && deploymentInfo.buildType !== 'local' && (
        <div className="space-y-2">
          <div className="text-sm font-semibold">Branch</div>
          <div className="text-sm font-mono text-muted">
            {deploymentInfo.branchName}
          </div>
        </div>
      )}

      <div className="space-y-2">
        <div className="text-sm font-semibold">Build Time</div>
        <div className="text-sm text-muted">
          {new Date(deploymentInfo.buildTime).toLocaleString()}
        </div>
      </div>
    </div>
  )
}

